export class SortFields extends Error {
  constructor (path) {
    super(`"${path}" is not present in sortedData in BaseTable`)
  }
}
